import { render } from "./BoardModalRead.vue?vue&type=template&id=4cb2df8b&scoped=true"
import script from "./BoardModalRead.vue?vue&type=script&lang=js"
export * from "./BoardModalRead.vue?vue&type=script&lang=js"

import "./BoardModalRead.vue?vue&type=style&index=0&id=4cb2df8b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cb2df8b"

export default script